var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMutation, useQueryClient } from 'react-query';
import { useAxios } from 'shared/hooks';
import { queryCache } from '../../../../reactQuery';
import { TourFlag, useTour } from 'shared/features/tour';
import { useNoteSetupContext } from 'shared/features/note-setup';
/**
 * Sends a sign request for a note
 */
export var useSignNote = function (_a) {
    var onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    var _b = useTour(), activate = _b.activate, silentComplete = _b.silentComplete;
    var noteSetupState = useNoteSetupContext();
    var axios = useAxios();
    return useMutation(function (values) {
        return axios.request({
            method: 'POST',
            data: values,
            url: "/api/v1/notes/".concat(values.id, "/sign"),
        });
    }, {
        onError: onError,
        onSuccess: function (_a, variables) {
            var data = _a.data;
            queryCache.setQueryData(['note', data.data.id], data.data);
            queryClient.invalidateQueries('notes');
            queryClient.invalidateQueries('past_interactions');
            queryClient.invalidateQueries('todo_notes');
            queryClient.invalidateQueries('signed_notes');
            queryClient.invalidateQueries('upcoming');
            queryClient.invalidateQueries('template'); // make sure copy forward doesn't hang on to old data
            queryClient.invalidateQueries('member-planned-followup');
            // If signing an appointment note, activate undo tour
            if (data.data.rotomAppointmentId) {
                activate(TourFlag.undoNote);
                silentComplete(TourFlag.undoNote);
                // update note setup
                queryCache.setQueryData(['note-setup', data.data.rotomAppointmentId], __assign(__assign({}, noteSetupState.noteSetupQuery.data), { existingNote: data.data }));
            }
            onSuccess && onSuccess(data.data, variables);
        },
    });
};
